"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CosmicSmashAbilityHandler = exports.CosmicSmashActorAbilityFactory = exports.CosmicSmashAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Random_1 = require("../../utils/Random");
const core_1 = require("../../core/effects/core");
const Duration_1 = require("../../core/Duration");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class CosmicSmashAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.CosmicSmash;
        this.__typeName = "CosmicSmash";
    }
}
exports.CosmicSmashAbilityArgs = CosmicSmashAbilityArgs;
let CosmicSmashActorAbilityFactory = class CosmicSmashActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("CosmicSmash", "AllEnemies", 4);
    }
};
CosmicSmashActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("CosmicSmash")
], CosmicSmashActorAbilityFactory);
exports.CosmicSmashActorAbilityFactory = CosmicSmashActorAbilityFactory;
let CosmicSmashAbilityHandler = class CosmicSmashAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const enemies = container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies);
        const power = Math.round(180 / enemies.length);
        container.applyMultiAttack({
            sequence,
            attackerId: ability.invokerId,
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            targets: enemies.map(targetId => ({
                targetId,
                damages: [
                    AbilityDamage_1.AbilityDamage.Focus("Chaos", power)
                ],
                effects: [
                    (0, Random_1.randomPercent)() <= 25 && {
                        targetId,
                        effect: new core_1.StunEffectArgs(),
                        duration: Duration_1.Duration.Turns(1),
                    }
                ].filter(Boolean)
            }))
        });
    }
};
CosmicSmashAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.CosmicSmash)
], CosmicSmashAbilityHandler);
exports.CosmicSmashAbilityHandler = CosmicSmashAbilityHandler;
